import { CloseIcon, ExpandMoreIcon } from '@dhl-ui/icons'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiAutocomplete = () =>
  ({
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: <ExpandMoreIcon fontSize="small" />,
        clearIcon: <CloseIcon fontSize="small" />,
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&.MuiInputBase-sizeSmall': {
              // enforce padding again
              padding: spacing(0, 2, 0),
            },
            '> .MuiAutocomplete-endAdornment': {
              flexWrap: 'nowrap',
              alignItems: 'center',
              display: 'flex',
            },
            '> .DhlAutocomplete-tags-root': {
              display: 'flex',
              overflow: 'hidden',
              gap: spacing(0.75),
              // our Chip, used for the multiple version
              '> .DhlChip': {
                '> .MuiBox-root': {
                  overflow: 'hidden',
                },
                '> .DhlSvgStack-root': {
                  flexShrink: 0,
                  height: spacing(2.5),
                  width: spacing(2.5),

                  svg: {
                    transform: `translateY(${spacing(0.25)}) translateX(${spacing(0.125)})`,
                    height: spacing(2),
                  },
                },
              },
              '> .DhlAutocomplete-chip-more': {
                display: 'flex',
                alignSelf: 'auto',
              },
            },
          },
          '& .MuiFormControl-root > .MuiOutlinedInput-root': {
            '> .MuiInputBase-input': {
              paddingLeft: 0,
            },
          },
          // Mui has some fun applications of the styling;
          '&:is(.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon, .MuiAutocomplete-hasPopupIcon, .MuiAutocomplete-hasClearIcon) .MuiOutlinedInput-root':
            {
              padding: spacing(0, 2, 0),
            },

          '& .MuiFormControl-root:has(.MuiInputLabel-root) > .MuiOutlinedInput-root': {
            padding: spacing(0, 2, 0),
            '> .MuiAutocomplete-endAdornment': {
              display: 'flex',
              alignSelf: 'center',
              flexShrink: 0,
              marginTop: spacing(0.25),
            },
            alignItems: 'baseline',
            // ensure the 'more' tag is properly aligned:
            '> .MuiAutocomplete-tag': {
              marginLeft: 0,
              marginRight: 0,
            },
            '> .DhlAutocomplete-tags-root': {
              transform: `translateY(${spacing(-0.5)})`,
            },

            '> .MuiInputBase-input': {
              paddingLeft: 0,
            },
          },
        },
        inputRoot: {
          gap: spacing(0.75),
          paddingRight: spacing(2),
          flexWrap: 'nowrap',
        },
        clearIndicator: {
          visibility: 'visible',
          '& .MuiSvgIcon-root': {
            // prevent misalignment:
            transform: 'unset !important',
            // prevent overrides for certain sizes (small)
            fontSize: spacing(2.5),
          },
        },
        popupIndicator: {
          '& .MuiSvgIcon-root': {
            // prevent misalignment:
            transform: 'unset !important',
            // prevent overrides for certain sizes (small)
            fontSize: spacing(2.5),
          },
        },
      },
    },
  }) satisfies ComponentCreation
